import { Group, Paper, Stack } from '@mantine/core';
import type { ReactNode } from 'react';

/** Gap between filter row and table card — matches caseload tab rhythm. */
export const BILLING_TAB_FILTER_TABLE_GAP = 'md' as const;

export interface BillingTabPanelLayoutProps {
  filters?: ReactNode;
  filterActions?: ReactNode;
  alerts?: ReactNode;
  children: ReactNode;
}

/**
 * Client portal billing tab shell: filter row above a bordered table card.
 * Mirrors {@link CaseloadTabPanelLayout} so search/filters sit outside the table.
 */
export function BillingTabPanelLayout({
  filters,
  filterActions,
  alerts,
  children,
}: BillingTabPanelLayoutProps): JSX.Element {
  const showFilterRow = filters != null || filterActions != null;

  return (
    <Stack gap={BILLING_TAB_FILTER_TABLE_GAP}>
      {showFilterRow ? (
        <Group justify="space-between" align="center" wrap="wrap" gap="md">
          {filters ? (
            <Group gap="md" wrap="wrap" style={{ flex: 1 }}>
              {filters}
            </Group>
          ) : null}
          {filterActions}
        </Group>
      ) : null}
      {alerts}
      <Paper p="lg" withBorder radius="md">
        {children}
      </Paper>
    </Stack>
  );
}
